
// ===== Variables


// News Load More
var nfIsLoading = false;
var nfMoreData = true;
var nfPage = 1;


var speed = '.2';
var transition_speed = '200';
var transition_easing = 'Sine.easeOut';

var bp_wrapper_width = '1780';
var bp_widescreen = '1999';
var bp_large_desktop = '1599';
var bp_med_desktop = '1440';
var bp_desktop = '1280';  // Spaces cards: 3
// var bp_tablet_landscape = '1079';
var bp_tablet_landscape = '1024';
var bp_cmsMobile = '991';
var bp_tablet_portrait = '767'; // Spaces cards: 2
var bp_large_phone = '599';
var bp_phone = '479'; // Spaces cards: 3

var RowFadeInOn = false;

var tooltip_shortlist_add = 'Add to Shortlist';
var tooltip_shortlist_remove = 'Remove from Shortlist';

// var arrow_right = '<svg class="icon"><use xlink:href="/wp-content/themes/liquid-central/img/icon.svg#arrow" /></svg>';

var arrow_left = '<svg class="icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path data-name="butt color" fill="none" stroke="currentColor" stroke-miterlimit="10" stroke-width="1.1" d="M18 10H2"/><path fill="none" stroke="currentColor" stroke-linecap="square" stroke-miterlimit="10" stroke-width="1.1" d="M6.33 14.47L2 10l4.33-4.47"/></svg>';
var arrow_right = '<svg class="icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path fill="none" stroke="currentColor" stroke-miterlimit="10" stroke-width="1.2" d="M2.15 9.47h16"/><path fill="none" stroke="currentColor" stroke-linecap="square" stroke-miterlimit="10" stroke-width="1.2" d="M13.82 4.99l4.33 4.48-4.33 4.47"/></svg>';
var close_icon = '<svg class="icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path stroke="currentColor" stroke-width="2" stroke-linecap="square" stroke-miterlimit="10" d="M16.5 3.5l-13 13M16.5 16.5l-13-13"/></svg>';
var star_icon = '<svg class="icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M10.6 1.78l2.27 4.59a.66.66 0 0 0 .5.36l5.07.74a.66.66 0 0 1 .36 1.13l-3.67 3.57a.66.66 0 0 0-.19.59l.87 5a.66.66 0 0 1-1 .7l-4.53-2.38a.66.66 0 0 0-.62 0l-4.5 2.43a.66.66 0 0 1-1-.7l.87-5a.66.66 0 0 0-.19-.59L1.2 8.6a.66.66 0 0 1 .37-1.13l5.07-.74a.66.66 0 0 0 .5-.36L9.4 1.78a.66.66 0 0 1 1.2 0z" fill="" stroke="currentcolor" stroke-miterlimit="10" stroke-width="1.06"/></svg>';
var shortlist_star_icon = '<svg class="icon shortlist-star" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M10.6 1.78l2.27 4.59a.66.66 0 0 0 .5.36l5.07.74a.66.66 0 0 1 .36 1.13l-3.67 3.57a.66.66 0 0 0-.19.59l.87 5a.66.66 0 0 1-1 .7l-4.53-2.38a.66.66 0 0 0-.62 0l-4.5 2.43a.66.66 0 0 1-1-.7l.87-5a.66.66 0 0 0-.19-.59L1.2 8.6a.66.66 0 0 1 .37-1.13l5.07-.74a.66.66 0 0 0 .5-.36L9.4 1.78a.66.66 0 0 1 1.2 0z" fill="" stroke="currentcolor" stroke-miterlimit="10" stroke-width="1.06"/></svg>';
var phone_icon = '<svg class="icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M2 3.47c-1.43 2.15.28 6.67 4.07 10.46s8.31 5.5 10.46 4.07a.79.79 0 0 0 .22-.15l1.45-1.45a1.23 1.23 0 0 0-.12-1.73l-2.59-2.59a1.23 1.23 0 0 0-1.72-.08l-1.68 1.68a.53.53 0 0 1-.67 0 20.26 20.26 0 0 1-2.76-2.32 20.26 20.26 0 0 1-2.33-2.77.53.53 0 0 1 0-.67L8 6.23a1.23 1.23 0 0 0-.12-1.73L5.33 1.92A1.23 1.23 0 0 0 3.6 1.8L2.15 3.25a.79.79 0 0 0-.15.22z" fill="" stroke="currentColor" stroke-miterlimit="10" stroke-width="1.1"/></svg>';


var storageSupported = (typeof Storage !== "undefined") ? true: false;



// ===== Debouncing function from John Hann
// http://unscriptable.com/index.php/2009/03/20/debouncing-javascript-methods/

(function($,sr){
  var debounce = function (func, threshold, execAsap) {
      var timeout;

      return function debounced () {
          var obj = this, args = arguments;
          function delayed () {
              if (!execAsap)
                  func.apply(obj, args);
                
              timeout = null;
          }

          if (timeout)
              clearTimeout(timeout);
          else if (execAsap)
              func.apply(obj, args);

          timeout = setTimeout(delayed, threshold || 100);
      };
  };
  // smartresize 
  jQuery.fn[sr] = function(fn){  return fn ? this.bind('resize', debounce(fn)) : this.trigger(sr); };

})(jQuery,'smartresize');




// ===== CMS Format
// <i class="icon-arrow-right"></i>
function formatCmsComponents() {

  // add arrows to buttons created via cms
  var cms_btn = $('.cms-btn.primary-btn')
  if (cms_btn.length > 0) {

    cms_btn.each(function () {
      var link = $(this);
      var icon = '<i class="icon-arrow-right"></i>';

      link.prepend(icon);

    })
  };


  // CTA Call btn
  var cms_btn = $('.cms-btn.cta-call')
  if (cms_btn.length > 0) {

    cms_btn.each(function () {
      var link = $(this);
      var text = link.html();
      var icon = '<i class="icon-phone"></i>';
      link.addClass('reveal-number is-min has-icon');
      link.html(phone_icon + '<span class="text">'+ text+'</span>');

    })
  };

  // ==== CMS table //Prem 06/03/2018: we are wrapping table from backend when saving 
  /*if ( $('.cms-table').length > 0 ) {

    $('.cms-table').each(function () {
      $(this).wrap('<div class="table-responsive"></div>');
    })

  }*/
}


function resizeIframe(iframe) {

  iframe
    .data('iframeRatio', iframe.height() / iframe.width())
    .removeAttr('height')
    .removeAttr('width')
    .css('margin','0 auto');

  if ( iframe.length < 1 ) { return; }

  var container = iframe.parent('.video-container');

  var containerHeight = container.height();
  var newWidth = container.width();

  // // Resize video according to its aspect ratio
  var newHeight = newWidth * iframe.data('iframeRatio');


  // // if video taller than window
  if ( newHeight > containerHeight ) {
    newHeight = containerHeight;
    newWidth = newHeight / iframe.data('iframeRatio');
  }

  iframe
    .width(newWidth)
    .height(newHeight)
    // .css({
    //   'opacity': 1,
    //   'visibility': 'visible'
    // })
    ;
    iframe.removeClass('is-hidden');
};
